import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MediaBtnContainer } from '../../../pre-meeting/components/Buttons'
import { useZoomContext } from '../../../../context/ZoomContext'
import { useSessionParams } from '../../../../hooks/useSessionParams'
import { useUserCourses } from '../../../../pages/meeting-view/hooks/useCourses'
import { useContentSharing } from '../../../../context/ContentSharingContext'
import StopSharingModal from '../../../../components/Modals/StopSharingModal'

export const StopShareContent = () => {
    const { setSidebarMode, setConfirmationDialog } = useZoomContext()
    const { isContentSharer, stopSharingContent } = useContentSharing()
    const { room } = useSessionParams()
    const { currentCourse } = useUserCourses()
    const enableSharedContent = !!currentCourse?.courseFlags.enableSharedContent

    // Don't render the component if content sharing is not enabled for this course
    // or if we're in the general room
    if (!enableSharedContent || room === 'general') return null

    const handleStopSharing = () => {
        // If user is sharing content, show confirmation modal
        if (isContentSharer) {
            setConfirmationDialog(
                <StopSharingModal
                    onConfirm={() => {
                        // Stop sharing and close the modal and sidebar
                        stopSharingContent()
                        setSidebarMode(null)
                        setConfirmationDialog(undefined)
                    }}
                    onCancel={() => {
                        // Just close the modal without stopping sharing
                        setConfirmationDialog(undefined)
                    }}
                />
            )
        }
    }

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        if (isContentSharer) {
            handleStopSharing()
        }
    }

    return (
        <div>
            <MediaBtnContainer square onClick={handleClick}>
                <div style={{ position: 'relative' }}>
                    <FontAwesomeIcon icon={['far', 'times']} />
                </div>
            </MediaBtnContainer>
        </div>
    )
}
